import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "onScroll"];
import { useContext } from 'react';
import styled from 'foundations-theming/utils';
import { rgba } from '../../utils/color';
import { TypeaheadContext } from './TypeaheadContext';
import { filterTokenProps } from '../../../utils/filterTokenProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { getFocusStyleObject } from '../../utils/focus/focus.style';
import { DROPDOWN_MENU_HEIGHT } from '../../constants';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledTypeaheadResultsList = styled.ul.withConfig({
  displayName: "TypeaheadResults__StyledTypeaheadResultsList",
  componentId: "xk4u6s-0"
})(({
  theme,
  $typeaheadResultsStyleOverrides,
  $cssStyles
}) => {
  return Object.assign({
    WebkitTapHighlightColor: rgba(theme.color['specialty-scrim'], 0) /* Disable tap highlight */,
    position: 'relative',
    borderRadius: 'inherit',
    listStyle: 'none',
    maxHeight: DROPDOWN_MENU_HEIGHT,
    overflowX: 'hidden',
    overflowY: 'auto',
    margin: theme.space['0'],
    padding: theme.space['0'],
    backgroundColor: theme.color['fill-surface-default']
  }, getFocusStyleObject({
    theme
  }), $typeaheadResultsStyleOverrides, $cssStyles);
});
export const TypeaheadResults = _ref => {
  var _useContext$typeahead, _useContext;
  let {
      children,
      onScroll
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const typeaheadResultsStyleOverrides = (_useContext$typeahead = (_useContext = useContext(TypeaheadContext)) === null || _useContext === void 0 ? void 0 : _useContext.typeaheadResultsStyleOverrides) !== null && _useContext$typeahead !== void 0 ? _useContext$typeahead : {};
  const {
    tokenProps,
    restProps
  } = filterTokenProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsx(StyledTypeaheadResultsList, Object.assign({}, restProps, {
    onScroll: onScroll,
    role: "listbox",
    $typeaheadResultsStyleOverrides: typeaheadResultsStyleOverrides,
    $cssStyles: cssStyles,
    onMouseDown: e => {
      const rect = e.currentTarget.getBoundingClientRect();
      const isOnScrollbar = e.clientX > rect.right - 15; // Approximate scrollbar width

      if (isOnScrollbar) {
        e.stopPropagation();
        e.preventDefault();
      }
    },
    children: children
  }));
};